import React from 'react';
import Tile from '../components/common/Tile';
import TopInstructionAndLink from '../components/TopInstructionAndLink';
import FixedContainer from '../components/common/FixedContainer';
import LinkButton from '../components/buttons/LinkButton';
import ReactGA from 'react-ga';
import AccessoriesShop from '../components/Masonry/images/accessories.png';

const SkipAccessories = () => {
  ReactGA.event(
    {
      category: 'Skip Accessories',
      action: 'Skip Accessories',
      transport: 'beacon',
    },
    ['tracker1', 'tracker2'],
  );
  return (
    <div className="container accessories-start accessories-start--no-flex accessories-start--no-padding">
      <TopInstructionAndLink
        link="/accessories-configuration"
        text="Czy na pewno chcesz pominąć ten krok? Elementy wyposażenia nie zostały wybrane"
      />
      <div>
        <Tile
          img={AccessoriesShop}
          mainText="Nie wiesz jakie akcesoria potrzebujesz?"
          secondaryText="Zastosuj wyposażenie rekomendowane"
          icon
        />
      </div>
      <FixedContainer padding>
        <LinkButton text="pomiń" link="/summary" color="white" />
        <LinkButton text="wróć" link="/accessories-configuration" />
      </FixedContainer>
    </div>
  );
};

export default SkipAccessories;
